import { render, staticRenderFns } from "./MainHeaderInfo.vue?vue&type=template&id=7570aee8"
import script from "./MainHeaderInfo.vue?vue&type=script&lang=js"
export * from "./MainHeaderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports